const translations = {
  en: {
    // Navbar
    'nav.home': 'Home',
    'nav.features': 'Features',
    'nav.partner': 'Partner With Us',
    'nav.about': 'About',
    'nav.contact': 'Contact',
    'nav.getStarted': 'Get Started',

    // Hero
    'hero.badge': 'Advanced Delivery Management Platform',
    'hero.title1': 'Retail Delivers Smarter',
    'hero.title2': 'with',
    'hero.sub': 'Discover never-before-seen insights into your delivery and customer experience with AI-driven route optimization and real-time tracking.',
    'hero.cta1': 'Get Started Free',
    'hero.cta2': 'See Features →',

    // Clients
    'clients.label': 'Trusted by industry leaders',

    // Features section
    'features.label': 'Home Delivery Management Platform',
    'features.title': 'Everything You Need to Deliver Smarter',
    'features.link': 'Get Started →',

    // Feature cards
    'feat.dispatch.title': '2× Faster Automated Dispatch',
    'feat.dispatch.desc': 'Speed up your entire delivery cycle. Smarter dispatching, optimized prep times — every order goes out faster and hits customer promise times consistently.',
    'feat.clubbing.title': '99.9% Automated Order Clubbing',
    'feat.clubbing.desc': 'Orders are auto-grouped and dispatched to the right driver in seconds — no manual decisions, no delays. Hot or high-value orders take priority automatically.',
    'feat.analytics.title': 'Deep-Dive Analytics',
    'feat.analytics.desc': 'Break down every second of delivery time — prep, fetching, waiting, drop-off — to spot improvement areas. Compare stores and fleets to see what\'s holding you back.',
    'feat.route.title': 'AI Route Optimization',
    'feat.route.desc': 'Our AI calculates the fastest, most cost-efficient routes in real time, adapting to traffic, distance, and driver availability automatically.',
    'feat.tracking.title': 'Live GPS Tracking',
    'feat.tracking.desc': 'Every delivery tracked in real time. Stores and clients see exactly where their package is at all times. SMS updates keep customers informed automatically.',
    'feat.fraud.title': 'AI Fraud Detection',
    'feat.fraud.desc': 'Route validation and anomaly detection flag suspicious activity before it costs you. Know instantly when a driver deviates from the assigned route.',

    // Stats
    'stats.costs': 'Cut in Operation Costs',
    'stats.productivity': 'Fleet Productivity Boost',
    'stats.automation': 'Dispatch Automation',
    'stats.faster': 'Faster Deliveries',

    // Blindspot section
    'blindspot.label': 'Turn Blindspots into Opportunities',
    'blindspot.title': 'Full Visibility Into Every Operation',
    'blindspot.body': 'Route Rover automatically flags delayed trips, missed orders, and SLA risks before they reach your customers. Transform raw operational data into actionable insights.',
    'blindspot.cta1': 'Get Started',
    'blindspot.cta2': 'Learn More',
    'blindspot.mock.title': 'Route Rover Dashboard',
    'blindspot.mock.orders': 'Orders Today',
    'blindspot.mock.ontime': 'On-Time Rate',
    'blindspot.mock.avg': 'Avg Delivery',
    'blindspot.mock.drivers': 'Active Drivers',

    // Testimonials
    'test.label': 'What Our Users Say',
    'test.title': 'Trusted by Operations Teams',

    // CTA Banner
    'cta.title': 'Ready to Optimize Every Route?',
    'cta.sub': 'Join leading retailers and delivery companies already using Route Rover.',
    'cta.btn': 'Request a Demo',

    // Footer
    'footer.desc': 'The advanced delivery management platform connecting stores and clients seamlessly.',
    'footer.company': 'Company',
    'footer.about': 'About Us',
    'footer.partner': 'Partner With Us',
    'footer.careers': 'Careers',
    'footer.features': 'Features',
    'footer.dispatch': 'Auto Dispatch',
    'footer.tracking': 'Live Tracking',
    'footer.route': 'Route Optimization',
    'footer.analytics': 'Analytics',
    'footer.multistore': 'Multi-Store',
    'footer.contact': 'Contact',
    'footer.demo': 'Request Demo',
    'footer.privacy': 'Privacy Policy',
    'footer.rights': 'All rights reserved.',

    // Partner page
    'partner.badge': 'Partnership Program',
    'partner.title1': 'Partner with Route Rover',
    'partner.title2': 'to Reshape the Future of Delivery',
    'partner.sub': 'Collaborate with an industry leader to offer your clients cutting-edge delivery management and automation solutions.',
    'partner.cta': 'Apply Now',
    'partner.intro.title': 'Drive innovation across delivery operations',
    'partner.intro.body': 'Route Rover is the region\'s leading delivery management platform built to transform the way stores dispatch, track, and manage their fleets. Whether you\'re a POS provider, logistics aggregator, software integrator, or business consultant — partnering with Route Rover means joining a smarter ecosystem built for efficiency, control, and customer satisfaction.',
    'partner.tech': 'Our Tech Partners',
    'partner.reseller.title': 'Reseller Partner',
    'partner.reseller.desc': 'Earn by introducing Route Rover\'s delivery management solutions to retail and F&B businesses. Get sales support, training, and commissions for every client you bring in.',
    'partner.tech.title': 'Tech Integration Partner',
    'partner.tech.desc': 'Integrate your POS, ERP, eCommerce, payment, or logistics platform with Route Rover to deliver a unified experience for shared clients.',
    'partner.signup': 'Apply Now',
    'partner.why.title': 'Why partner with Route Rover?',
    'partner.why1.title': 'Broaden your impact',
    'partner.why1.desc': 'Tap into new markets and audiences by joining forces with us. Together, we\'ll extend your footprint and open doors to opportunities that go far beyond your current reach.',
    'partner.why2.title': 'Strengthen your solutions',
    'partner.why2.desc': 'Enrich your portfolio by integrating with our AI-powered platform. The result is a stronger, more complete offering that brings greater value to your clients.',
    'partner.why3.title': 'Fuel your success',
    'partner.why3.desc': 'Accelerate growth with the backing of Route Rover\'s expertise, tools, and support. Our partnership is built to help you scale faster and stay ahead of the curve.',
    'partner.form.title': 'Let\'s Build the Future of Smarter Delivery',
    'partner.form.sub': 'Fill in your details and our team will reach out within 24 hours.',
    'partner.form.name': 'Full Name',
    'partner.form.company': 'Company Name',
    'partner.form.email': 'Email Address',
    'partner.form.phone': 'Phone Number',
    'partner.form.type': 'Partnership Type',
    'partner.form.type.reseller': 'Reseller Partner',
    'partner.form.type.tech': 'Tech Integration Partner',
    'partner.form.type.consultant': 'Business Consultant',
    'partner.form.type.other': 'Other',
    'partner.form.message': 'Tell us about your business',
    'partner.form.submit': 'Submit Application',
    'partner.form.success': 'Thank you! We\'ll be in touch within 24 hours.',
  },

  ar: {
    // Navbar
    'nav.home': 'الرئيسية',
    'nav.features': 'المميزات',
    'nav.partner': 'شراكة معنا',
    'nav.about': 'عن الشركة',
    'nav.contact': 'تواصل معنا',
    'nav.getStarted': 'ابدأ الآن',

    // Hero
    'hero.badge': 'منصة إدارة التوصيل المتقدمة',
    'hero.title1': 'توصيل أذكى للمتاجر',
    'hero.title2': 'مع',
    'hero.sub': 'اكتشف رؤى لم تتخيلها من قبل حول تجربة التوصيل والعملاء مع تحسين المسارات بالذكاء الاصطناعي والتتبع اللحظي.',
    'hero.cta1': 'ابدأ مجاناً',
    'hero.cta2': 'استكشف المميزات ←',

    // Clients
    'clients.label': 'موثوق به من قِبل رواد الصناعة',

    // Features section
    'features.label': 'منصة إدارة التوصيل المنزلي',
    'features.title': 'كل ما تحتاجه لتوصيل أذكى',
    'features.link': 'ابدأ الآن ←',

    // Feature cards
    'feat.dispatch.title': 'إرسال تلقائي أسرع مرتين',
    'feat.dispatch.desc': 'سرّع دورة التوصيل بأكملها. إرسال أذكى وأوقات تحضير محسّنة — كل طلب يخرج أسرع ويصل في الوقت المحدد باستمرار.',
    'feat.clubbing.title': '٩٩.٩٪ تجميع تلقائي للطلبات',
    'feat.clubbing.desc': 'يتم تجميع الطلبات وإرسالها للسائق المناسب في ثوانٍ — بدون قرارات يدوية أو تأخيرات. الطلبات العاجلة أو عالية القيمة تأخذ الأولوية تلقائياً.',
    'feat.analytics.title': 'تحليلات معمّقة',
    'feat.analytics.desc': 'حلّل كل ثانية في وقت التوصيل — التحضير، الاستلام، الانتظار، التسليم — لتحديد مناطق التحسين. قارن المتاجر والأساطيل لمعرفة ما يعيقك.',
    'feat.route.title': 'تحسين المسارات بالذكاء الاصطناعي',
    'feat.route.desc': 'يحسب الذكاء الاصطناعي لدينا أسرع المسارات وأكثرها كفاءة في الوقت الفعلي، متكيفاً مع حركة المرور والمسافة وتوافر السائقين تلقائياً.',
    'feat.tracking.title': 'تتبع GPS مباشر',
    'feat.tracking.desc': 'كل توصيلة تُتابَع في الوقت الفعلي. المتاجر والعملاء يرون بالضبط أين طلبهم في كل وقت. تحديثات SMS تُبقي العملاء على اطلاع تلقائياً.',
    'feat.fraud.title': 'كشف الاحتيال بالذكاء الاصطناعي',
    'feat.fraud.desc': 'التحقق من المسارات وكشف الشذوذ يُبلّغ عن النشاط المشبوه قبل أن يكلفك. اعرف فوراً عندما ينحرف سائق عن المسار المخصص.',

    // Stats
    'stats.costs': 'تخفيض في تكاليف التشغيل',
    'stats.productivity': 'زيادة في إنتاجية الأسطول',
    'stats.automation': 'أتمتة الإرسال',
    'stats.faster': 'توصيل أسرع',

    // Blindspot section
    'blindspot.label': 'حوّل النقاط العمياء إلى فرص',
    'blindspot.title': 'رؤية كاملة لكل عملية',
    'blindspot.body': 'يُبلّغ Route Rover تلقائياً عن الرحلات المتأخرة والطلبات الفائتة ومخاطر مستوى الخدمة قبل أن تصل لعملائك. حوّل البيانات التشغيلية الخام إلى رؤى قابلة للتنفيذ.',
    'blindspot.cta1': 'ابدأ الآن',
    'blindspot.cta2': 'تعرف أكثر',
    'blindspot.mock.title': 'لوحة تحكم Route Rover',
    'blindspot.mock.orders': 'طلبات اليوم',
    'blindspot.mock.ontime': 'معدل الالتزام بالوقت',
    'blindspot.mock.avg': 'متوسط التوصيل',
    'blindspot.mock.drivers': 'سائقون نشطون',

    // Testimonials
    'test.label': 'ما يقوله مستخدمونا',
    'test.title': 'موثوق به من فرق العمليات',

    // CTA Banner
    'cta.title': 'مستعد لتحسين كل مسار؟',
    'cta.sub': 'انضم إلى كبار تجار التجزئة وشركات التوصيل التي تستخدم Route Rover بالفعل.',
    'cta.btn': 'اطلب عرضاً تجريبياً',

    // Footer
    'footer.desc': 'منصة إدارة التوصيل المتقدمة التي تربط المتاجر بالعملاء بسلاسة.',
    'footer.company': 'الشركة',
    'footer.about': 'عن الشركة',
    'footer.partner': 'شراكة معنا',
    'footer.careers': 'وظائف',
    'footer.features': 'المميزات',
    'footer.dispatch': 'الإرسال التلقائي',
    'footer.tracking': 'التتبع المباشر',
    'footer.route': 'تحسين المسارات',
    'footer.analytics': 'التحليلات',
    'footer.multistore': 'متعدد المتاجر',
    'footer.contact': 'تواصل معنا',
    'footer.demo': 'طلب عرض',
    'footer.privacy': 'سياسة الخصوصية',
    'footer.rights': 'جميع الحقوق محفوظة.',

    // Partner page
    'partner.badge': 'برنامج الشراكة',
    'partner.title1': 'شارك Route Rover',
    'partner.title2': 'لإعادة تشكيل مستقبل التوصيل',
    'partner.sub': 'تعاون مع رائد في الصناعة لتقديم حلول إدارة التوصيل والأتمتة المتطورة لعملائك.',
    'partner.cta': 'قدّم طلباً الآن',
    'partner.intro.title': 'قُد الابتكار عبر عمليات التوصيل',
    'partner.intro.body': 'Route Rover هي المنصة الرائدة في المنطقة لإدارة التوصيل، مبنية لتحويل طريقة إرسال المتاجر وتتبعها وإدارة أساطيلها. سواء كنت مزود نقاط بيع، أو مجمّع لوجستي، أو مدمج برامج، أو مستشار أعمال — الشراكة مع Route Rover تعني الانضمام إلى منظومة أذكى مبنية للكفاءة والتحكم ورضا العملاء.',
    'partner.tech': 'شركاؤنا التقنيون',
    'partner.reseller.title': 'شريك إعادة بيع',
    'partner.reseller.desc': 'اكسب عمولات بتقديم حلول Route Rover لتجار التجزئة ومطاعم F&B. احصل على دعم مبيعات وتدريب وعمولات على كل عميل تجلبه.',
    'partner.tech.title': 'شريك تكامل تقني',
    'partner.tech.desc': 'ادمج منصة نقاط البيع أو ERP أو التجارة الإلكترونية أو الدفع أو اللوجستيات مع Route Rover لتقديم تجربة موحدة للعملاء المشتركين.',
    'partner.signup': 'قدّم طلباً الآن',
    'partner.why.title': 'لماذا الشراكة مع Route Rover؟',
    'partner.why1.title': 'وسّع تأثيرك',
    'partner.why1.desc': 'اطّلع على أسواق وجماهير جديدة بالتعاون معنا. معاً، سنوسّع نطاق وصولك ونفتح أبواباً لفرص تتجاوز حدودك الحالية بكثير.',
    'partner.why2.title': 'عزّز حلولك',
    'partner.why2.desc': 'أثرِ محفظتك بالتكامل مع منصتنا المدعومة بالذكاء الاصطناعي. النتيجة عرض أقوى وأكثر اكتمالاً يضيف قيمة أكبر لعملائك.',
    'partner.why3.title': 'أجّج نجاحك',
    'partner.why3.desc': 'سرّع النمو بدعم خبرات Route Rover وأدواتها ودعمها. شراكتنا مبنية لمساعدتك على التوسع بشكل أسرع والبقاء في المقدمة.',
    'partner.form.title': 'لنبني معاً مستقبل التوصيل الذكي',
    'partner.form.sub': 'املأ بياناتك وسيتواصل معك فريقنا خلال ٢٤ ساعة.',
    'partner.form.name': 'الاسم الكامل',
    'partner.form.company': 'اسم الشركة',
    'partner.form.email': 'البريد الإلكتروني',
    'partner.form.phone': 'رقم الهاتف',
    'partner.form.type': 'نوع الشراكة',
    'partner.form.type.reseller': 'شريك إعادة بيع',
    'partner.form.type.tech': 'شريك تكامل تقني',
    'partner.form.type.consultant': 'مستشار أعمال',
    'partner.form.type.other': 'أخرى',
    'partner.form.message': 'أخبرنا عن شركتك',
    'partner.form.submit': 'إرسال الطلب',
    'partner.form.success': 'شكراً! سنتواصل معك خلال ٢٤ ساعة.',
  },
};

export default translations;
